/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {onboard} from '../api'

export const useMutationOnboard = createReactQueryMutationHook('onboard', onboard)
